import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';

interface IProps {
  ref?: any;
  formCode?: string;
  itemData?: any;
}

const View = (props: IProps) => {
  return (
    <div>
      <table className={'preview-table'}>
        <colgroup>
          <col width={'15%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <tbody>
          <tr>
            <th rowSpan={3} className={'saf-border-bottom-none saf-bg-white'}>
              SUBCONTRACTOR
            </th>
            <th colSpan={2}>Signed Date</th>
            <th colSpan={2}>PERFORMING AUTHORITY</th>
            <th colSpan={2}>Signed Date</th>
            <th colSpan={2}>LIFTING SUPERVISOR / AREA HSSE</th>
          </tr>
          <tr>
            <th>DATE</th>
            <th>TIME</th>
            <th>DATE</th>
            <th>SIGN</th>
            <th>DATE</th>
            <th>SIGN</th>
            <th>DATE</th>
            <th>SIGN</th>
          </tr>
          <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
